import { getBrowserId } from './browserId'
import { encrypt } from './globalHelper'
import { apiLanguageIdMap } from '@/format/lang'
import { useLanguage } from '@/composition/useLanguage'

/**
 * 获取Web-X7sy-Dev请求头信息
 */
export const getWebX7syDev = () => {
  const { curLanguage } = useLanguage()
  const browserId = getBrowserId()
  const isForeign = window.isInternational ? 1 : -1
  const language = window.isInternational ? apiLanguageIdMap[unref(curLanguage)] : apiLanguageIdMap['cn']

  return encrypt({ browserId, isForeign, language })
}
